import {
  Component,
  ComponentRef,
  ElementRef,
  OnInit,
  SecurityContext,
} from '@angular/core';
import {
  ApplicationState,
  getCopperOutPhasingOffer,
  getProductDetailsPending,
  getProductDetailsTechnicalError,
  getSelectedProductDetails,
  getUserProduct,
} from '../../../../store/reducers';
import {
  getTealiumLocation,
  InternetProduct,
  Location,
} from '@dch/products-business-logic';
import { GetProductDetails } from '../../../../store/actions/product-details.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  CustomerService,
  InceptionService,
  TranslationService,
} from '@proximus/ng-common';
import { OnDestroyHookDirective } from '../../../../shared/hooks';
import { getPiiServiceId, savePii } from '../../../../shared/pii/pii.utils';
import { Product as UsageProduct } from '@proximus/usage-business-logic';
import { getUsageProductFrom } from 'src/app/shared/usage/util';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalService } from '@proximus/ng-common-components';
import { InternetProductSelectorModalComponent } from '../internet-product-selector-modal/internet-product-selector-modal.component';
import * as ProductsActions from '../../../../store/actions/products.actions';
import * as OffersActions from '../../../../store/actions/offers.actions';
import * as MagnoliaConfigActions from '../../../../store/actions/magnolia-config.actions';
import { IOffer } from '@proximus/common-business-logic';
import { getInternetProductDescription } from '../../../../shared/giga-pack-speed/giga-pack-speed';

declare let inception;
@Component({
  selector: 'mprd-internet-level-two',
  templateUrl: './internet-level-two.component.html',
})
export class InternetLevelTwoComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  selectedProduct: InternetProduct;
  usageProduct: UsageProduct | undefined;
  isRes: boolean;
  hasError: boolean;
  isPending: boolean;
  tealiumLocation: string;
  remainingDaysLabel: string | undefined;
  fragmentId: string;
  showHgw4 = false;
  showBipt = false;
  serviceId;

  faqHtml?: string;

  isDeepLink = false;
  productsAvailableForDeepLink: Array<InternetProduct> = [];
  productsAvailableForDeepLinkLoaded: boolean;
  installationAddresses: { [key: string]: Location };
  copperOutPhasingOffer: IOffer;

  productSubDescription: string;

  constructor(
    private route: ActivatedRoute,
    private store: Store<ApplicationState>,
    private inceptionService: InceptionService,
    private translationService: TranslationService,
    private elementRef: ElementRef,
    private customerService: CustomerService,
    private router: Router,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private modalService: ModalService,
  ) {
    super();
  }

  ngOnInit() {
    this.isDeepLink = this.router.url.includes('/deeplink/');
    if (this.router.url.includes('/deeplink/')) {
      this.getProducts();
      this.getCopperOutPhasingOffer();

      this.addSubscription(
        this.store.select(getUserProduct).subscribe((data) => {
          if (
            data &&
            ((data.packs && data.packs.length > 0) ||
              (data.outOfPacks && data.outOfPacks.length > 0))
          ) {
            this.productsAvailableForDeepLinkLoaded = true;
            if (this.productsAvailableForDeepLinkLoaded) {
              this.productsAvailableForDeepLink = this.filterInternetProducts(
                data.packs,
                data.outOfPacks,
              );
              this.installationAddresses = data.installationAddresses;
              if (this.productsAvailableForDeepLink.length >= 2) {
                this.modalService
                  .create<InternetProductSelectorModalComponent>(
                    InternetProductSelectorModalComponent,
                  )
                  .subscribe(
                    (
                      componentRef: ComponentRef<InternetProductSelectorModalComponent>,
                    ) => {
                      componentRef.instance.productsAvailableForDeepLink =
                        this.productsAvailableForDeepLink;
                      componentRef.instance.installationAddresses =
                        this.installationAddresses;
                      componentRef.instance.confirm = (
                        selectedInternetProduct,
                      ) =>
                        this.loadDetailsForSelectedProduct(
                          selectedInternetProduct,
                        );
                    },
                  );
              } else if (this.productsAvailableForDeepLink.length == 1) {
                this.loadDetailsForSelectedProduct(
                  this.productsAvailableForDeepLink[0],
                );
              } else {
                this.routeToOverview();
              }
            } else {
              if (this.productsAvailableForDeepLinkLoaded) {
                this.routeToOverview();
              }
            }
          } else {
            if (this.productsAvailableForDeepLinkLoaded) {
              this.routeToOverview();
            }
          }
        }),
      );
    } else {
      this.loadInternetDetails();
      this.getCopperOutPhasingOffer();
    }
  }

  private loadInternetDetails() {
    const serviceId = getPiiServiceId();
    if (serviceId) {
      this.addSubscription(
        this.store.select(getSelectedProductDetails).subscribe((value) => {
          if (value && value.internetProductDetails) {
            this.selectedProduct = value.internetProductDetails;
            this.usageProduct = getUsageProductFrom(this.selectedProduct);
            this.tealiumLocation = getTealiumLocation(
              this.selectedProduct as any,
            );
            this.showHgw4 =
              this.selectedProduct?.box?.parentProductMpcUuid === 'DXRJR' ||
              this.selectedProduct?.showHomeGatewaySection;
            this.productSubDescription =
              getInternetProductDescription(this.selectedProduct) +
              this.selectedProduct.accessNumber;
          }
        }),
      );

      this.addSubscription(
        this.route.params.subscribe((params) => {
          this.store.dispatch(
            new GetProductDetails({
              productType: 'internet',
              serviceId,
            }),
          );
        }),
      );

      this.addSubscription(
        this.customerService.getCustomerAccount().subscribe((value) => {
          this.isRes =
            value &&
            (value.getSelectedCustomer().subsegment === 'RES' ||
              value.getSelectedCustomer().subsegment === 'PRE');
        }),
      );

      this.addSubscription(
        this.store
          .select(getProductDetailsTechnicalError)
          .subscribe((value) => {
            this.hasError = value !== null;
          }),
      );

      this.addSubscription(
        this.store.select(getProductDetailsPending).subscribe((pending) => {
          this.isPending = pending;
        }),
      );
      this.addSubscription(
        this.route.fragment.subscribe((fragment) => {
          this.fragmentId = fragment;
        }),
      );

      this.addSubscription(
        this.store.select(getCopperOutPhasingOffer).subscribe((value) => {
          this.copperOutPhasingOffer = value;
        }),
      );

      this.scrollToFragment();

      const url = 'internet-details-faq%7EmgnlArea=body%7E.html';
      this.http.get(url, { responseType: 'text' }).subscribe((response) => {
        this.faqHtml = this.sanitizer.sanitize(SecurityContext.HTML, response);
      });

      this.translationService.parse(this.elementRef.nativeElement);
    } else {
      this.routeToOverview();
    }
  }

  private filterInternetProducts(packs: any, outOfPacks: any) {
    const internetProducts: Array<InternetProduct> = [];
    for (const pack of packs) {
      const coreProducts = pack?.coreProducts;
      const internetProduct: Array<InternetProduct> = coreProducts.filter(
        (product) => product.plc === 'FI' && product.labelIdentifier !== 'FON',
      );
      internetProducts.push(...internetProduct);
    }
    for (const outOfPack of outOfPacks) {
      const coreProducts = outOfPack?.coreProducts;
      const internetProduct: Array<InternetProduct> = coreProducts.filter(
        (product) => product.plc === 'FI' && product.labelIdentifier !== 'FON',
      );
      internetProducts.push(...internetProduct);
    }
    return internetProducts;
  }

  private routeToOverview() {
    this.router.navigate(['/overview']);
  }

  private loadDetailsForSelectedProduct(selectedProduct) {
    if (this.isDeepLink) {
      this.usageProduct = undefined;
      this.remainingDaysLabel = undefined;
    }

    this.selectedProduct = selectedProduct;
    savePii(this.selectedProduct.accessNumber);
    this.loadInternetDetails();
  }

  private getProducts() {
    this.store.dispatch(new ProductsActions.GetProducts());
    this.store.dispatch(new MagnoliaConfigActions.GetOptionGroupsConfig());
  }

  usageInitializedWith(remainingDaysLabel: string) {
    if (remainingDaysLabel) {
      this.remainingDaysLabel = remainingDaysLabel;
      this.initMasonry();
      if (this.fragmentId) {
        this.inceptionService.scrollToElement('#' + this.fragmentId);
      }
    }
  }

  initBipt() {
    this.initMasonry();
    this.showBipt = true;
  }

  initMasonry() {
    setTimeout(() => {
      inception.masonry('[data-masonry-container]');
    });
  }

  routeToInternetUsageDetails() {
    this.router.navigate(['/details/internet/usage']);
  }

  private scrollToFragment(): void {
    setTimeout(() => {
      if (this.fragmentId) {
        this.inceptionService.scrollToElement('#' + this.fragmentId);
      } else {
        this.inceptionService.scrollToElement('#internetLevelTwo');
      }
    });
  }

  private getCopperOutPhasingOffer() {
    this.store.dispatch(new OffersActions.GetCopperOutPhasingOffer());
  }
}
